import React, { useEffect, useState } from "react";
import { Dropdown, Breadcrumb, Row, Col } from "react-bootstrap";
import { Link } from "react-router-dom";
import Avatar from "../assets/img/User3.jpg";
import ConfigApp from "../common/config";

const Header = ({ title }) => {
  const [userData, setUserData] = useState(null);
  useEffect(() => {
    var userData = JSON.parse(localStorage.getItem("userDetail"));
    setUserData(userData);
  }, []);


  return (
    <header className="header">
      <Row>
        <Col xs={6} className="align-self-center">
          {/* <div className="mainbreadcrumb d-none d-md-block">
            <Breadcrumb>
              <Breadcrumb.Item href="#">Pages</Breadcrumb.Item>
              <Breadcrumb.Item active>{title}</Breadcrumb.Item>
            </Breadcrumb>
          </div> */}
        </Col>
        <Col xs={6} className="text-end">
          <div
            className="headerright"
            style={{ display: "inline-flex", alignItems: "center" }}
          >
            <Dropdown>
              <Dropdown.Toggle
                id="dropdown-basic"
                className="p-0"
                variant={null}
              >
                <img alt="" src={userData&&userData.user&&userData.user.image_url? ConfigApp.IMAGE_URL+userData.user.image_url:Avatar} />
              </Dropdown.Toggle>
              <Dropdown.Menu>
                <Dropdown.Item as={Link} to="/profile-settings">
                  Profile Settings
                </Dropdown.Item>
                <Dropdown.Item as={Link} to="/">
                  Logout
                </Dropdown.Item>
              </Dropdown.Menu>
            </Dropdown>
          </div>
        </Col>
      </Row>
    </header>
  );
};

export default Header;
